import React from 'react'
import { Card, CardBody, Col } from 'reactstrap'
import CardHeaderSpan from '../../../../../Utils/CommonComponents/CardHeaderSpan'
import { CommentsTitle, Href } from '../../../../../Utils/Constants'
import { H6, Image, LI, P, UL } from '../../../../../AbstractElements'
import { dynamicImage } from '../../../../../Utils'
import { blogCommentData } from '../../../../../Data/MiscellaneousData/BlogData'

export default function BlogComment() {
    return (
        <Col sm={12}>
            <Card className="blog-comment">
                <CardHeaderSpan headingClassName='pb-0 border-0' smallHeading={CommentsTitle} />
                <CardBody>
                    <UL className="comment-section simple-list">
                        {blogCommentData.map((item) => (
                            <LI key={item.id} className={item.id === 2 ? 'replay' : ''}>
                                <div className="d-flex">
                                    <Image src={dynamicImage(`avtar/${item.image}`)} alt="Generic placeholder image" />
                                    <div className="flex-grow-1">
                                        <H6>{item.name}</H6>
                                        <span>( {item.date} ) <a className="ms-1" href={Href}>{'reply'}</a></span>
                                        <P>{item.paragraph}</P>
                                    </div>
                                </div>
                            </LI>
                        ))}
                    </UL>
                </CardBody>
            </Card>
        </Col>
    )
}